document.addEventListener('DOMContentLoaded', rsThumbnailSlider );

// document.querySelector('.swiper-container').swiper;
function rsThumbnailSlider () {
  var $productContainer = $('.template-product');
  var $productImgThumbnails = $productContainer.find('.product-single__thumbnails');
  var $swiperContainer = $productImgThumbnails.find('.swiper-container');

  var windowLargeWidth = 992;
  var swiper = $swiperContainer[0].swiper; 

  var $scrollSlideControls = $('.desktop-slide-controls');
  var $scrollMediaContainer = $('.product-single__medias');


  $(document).on('click', 'a[href^="#"]', function (event) {
      if ( $($.attr(this, 'href')).length ) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - 50
        });
        window.location.hash = $(this).attr('href');
      }
  });  

  initChangeThumbnailsMobileDesktop();
  initScrollSlideControls();

  function initScrollSlideControls () {
    var circleButtonHtml = ''+
    '<button class="circleButton" aria-label></button>'
    $scrollMediaContainer.children().each( function (index) {
      var circleButtonHtml = '';
      var index1 = index+1;
      var targetId = 'product-img-'+index1;
      $(this).attr('id', targetId);
      circleButtonHtml += ''+
      '<a href="#'+targetId+'" class="circleButton" data-index="'+index1+'" aria-label="Go to Image '+index1+'"></a>'
      $scrollSlideControls.append(circleButtonHtml);
    });

    scrollSlideControlsPosition();
    descriptionIsStickyOrNot();

    descriptionPosition();
    activeSliderDotFromScroll();

    $(window).on('resize', function () {
      scrollSlideControlsPosition();
      descriptionIsStickyOrNot();
    } );
    $(window).on('scroll', function () {
      scrollSlideControlsPosition();
      descriptionPosition();
      activeSliderDotFromScroll();
    });
  }

  function scrollSlideControlsPosition () {
    var scrollableImageHeight = $scrollMediaContainer.children().first().outerHeight();
    var scrollSlideControlsHeight = $scrollSlideControls.outerHeight();
    var docOffset = $('#main').offset().top - $(window).scrollTop();
    var positionInsideMain = (scrollableImageHeight/2) - (scrollSlideControlsHeight/2);

    if ( docOffset < 0 ) docOffset = 0;
    
    // if ( $scrollSlideControls.offset().top >=  $scrollMediaContainer.offset().top + $scrollMediaContainer.outerHeight() ) {
    if ( $(window).scrollTop() + docOffset + positionInsideMain + scrollSlideControlsHeight >= $scrollMediaContainer.offset().top + $scrollMediaContainer.outerHeight() - positionInsideMain ) {
      $scrollSlideControls.css({
        top:($scrollMediaContainer.offset().top + $scrollMediaContainer.outerHeight() - scrollSlideControlsHeight -positionInsideMain )+'px',
        position: 'absolute'
      });
    }
    else {
      $scrollSlideControls.css({
        top:(docOffset+positionInsideMain)+'px',
        position: 'fixed'
      });
    }
  }
  function descriptionPosition () {
    var scrollableImageHeight = $scrollMediaContainer.children().first().outerHeight();
    var docOffset = $('#main').offset().top - $(window).scrollTop();
    var $descriptionContainer = $('.description-inner');
    var descriptionContainerHeight = $descriptionContainer.outerHeight();
    var positionInsideMain = (scrollableImageHeight/2) - (descriptionContainerHeight/2);

    if ( docOffset < 0 ) docOffset = 0;
    
    if ( $descriptionContainer.hasClass('sticky') ) {
      if ( $(window).scrollTop() + docOffset + positionInsideMain + descriptionContainerHeight >= $scrollMediaContainer.offset().top + $scrollMediaContainer.outerHeight() ) {
        $descriptionContainer.css({
          top:( docOffset + $scrollMediaContainer.outerHeight() - descriptionContainerHeight  )+'px',
          position: 'absolute'
        });
      }
      else {
        $descriptionContainer.css({
          top:(docOffset+positionInsideMain)+'px',
          position: 'fixed'
        });
      }
    }
    else {
      $descriptionContainer.css({
        position:'relative',
        top:'auto'
      })
    }
  }
  function activeSliderDotFromScroll () {
    var headerOffset = $('.sticky-header-wrapper').outerHeight();

    var foundActive = false;
    $scrollMediaContainer.children().each(function (index) {
      if ( foundActive === false && ($(window).scrollTop() + headerOffset < $(this).offset().top + $(this).outerHeight()) )  {
        $(this).addClass('active');
        $scrollSlideControls.children().eq(index).addClass('active');
        foundActive = true;
      }
      else {
        $(this).removeClass('active');
        $scrollSlideControls.children().eq(index).removeClass('active');
      }
    })
  }

  function descriptionIsStickyOrNot () {
    var $descriptionContainer = $('.description-inner');
    if ( window.innerWidth >= windowLargeWidth ) {
      $descriptionContainer
        .addClass('sticky')
        .css('width', $descriptionContainer.parent().width() );
    }
    else {
      $descriptionContainer.removeClass('sticky').css('width', 'auto' );
    }    
  }
  function initChangeThumbnailsMobileDesktop () {
    swiper.params.autoHeight = false;  
    changeThumbnailsMobileDesktop();
    $(window).on('resize', changeThumbnailsMobileDesktop );    
  }
  function changeThumbnailsMobileDesktop () {
    swiper.params.autoHeight = false;
    if ( window.innerWidth >= windowLargeWidth && !$productImgThumbnails.hasClass('hide') ) {
      $productImgThumbnails.addClass('hide');
    }
    else if ( window.innerWidth < windowLargeWidth && $productImgThumbnails.hasClass('hide') ) {
      $productImgThumbnails.removeClass('hide');
    }
  }
}